<my-content placeholder="navigation">
  <!-- <div class="form-group mt-2" style="display: none">
    <div class="form-check">
      <input type="checkbox" name="autoClose" id="autoClose" class="form-check-input" checked="true"
        [(ngModel)]="options.autoClose" />
      <label for="autoClose">Auto close alert after three seconds</label>
    </div>
  </div>
  <app-confirm-dialog></app-confirm-dialog>
  <router-outlet></router-outlet> -->
  <!-- <div class="jumbotron p-4">
        <div class="container text-center col-sm-3 alertCss">
            <app-alert></app-alert>
            <router-outlet></router-outlet>
        </div>
    </div> -->
  <!-- <div class="d-flex align-items-center justify-content-end">
    <a type="button" class="" href="/#/plan/plan/0">
      <i class="icon-arrow-left-circle menu-icon" title="Back" style="color: black; font-size: 20px"></i>
    </a>
  </div> -->
  <!-- <div class="col-sm-12" style="border-bottom: 1px solid #ccc"></div> -->
  <!-- <div>&nbsp;</div> -->
  <!-- modal-dialog-Start -->
  <div id="ModalPopUP1" class="modal fade" data-backdrop="static" data-keyboard="false" role="dialog">
    <div class="modal-dialog-FactSheet">
      <div class="modal-content">
        <div class="modal-header BlueHeader">
          <h4 class="Heading">{{ ModelFor }}</h4>
          <button type="button" class="close" (click)="this[CallFunctionOnCloseModal]()" data-dismiss="modal">
            &times;
          </button>
        </div>
        <div class="modal-body col-sm-12 form-group">
          <iframe width="100%" Height="400 px" frameBorder="0" [src]="modalURL | safe"></iframe>
        </div>
      </div>
    </div>
  </div>
  <!-- modal-dialog-end -->
  <!-- modal-dialog-Start -->
  <div id="ModalPopUP" class="modal fade" data-backdrop="static" data-keyboard="false" role="dialog">
    <div class="modal-dialog-FactSheet">
      <div class="modal-content">
        <div class="modal-header BlueHeader">
          <h4 class="Heading"> {{statusNo == 3 ? 'Convert to Notice' : 'Convert to Case' }}</h4>
          <br />
          <button type="button" class="close" (click)="this[CallFunctionOnCloseModal]();FormAddNoticeCaseorClosed.reset();" data-dismiss="modal">
            &times;
          </button>
        </div>
        <div class="modal-body col-sm-12 form-group">
          <button class="openModal" [hidden]="true" data-toggle="modal" (click)="OpenModalData()"
            data-target="#ModalPopUP">
            Open Modal
          </button>
          <div class="card">
            <div class="card-body">
              <form  [formGroup]="FormAddNoticeCaseorClosed"
                (ngSubmit)="onAddNoticeCaseorClosed(FormAddNoticeCaseorClosed.value)">
                @if (!HideCaseNotice) {
                  <div class="row">
                    <div class="col-12 col-md-6">
                      <div class="form-group">
                        <label for="Date" class="form-label">Date<span class="text-danger">*</span></label>
                        <mat-form-field class="fullwidth" appearance="outline">
                          <input matInput [readonly]="!editable" [min]="minDate" formControlName="Date" [max]="maxDate"
                            [matDatepicker]="pickerevent" placeholder="Choose Case/Notice Date" />
                          <mat-datepicker-toggle matSuffix [for]="pickerevent"></mat-datepicker-toggle>
                          <mat-datepicker #pickerevent></mat-datepicker>
                        </mat-form-field>
                        @if (FormAddNoticeCaseorClosed.get('Date').touched && FormAddNoticeCaseorClosed.get('Date').invalid) {
                          <mat-error>
                            @if (FormAddNoticeCaseorClosed.get('Date').errors?.['required']) {
                              Date is required.
                            }
                          </mat-error>
                        }
                      </div>
                    </div>
                    <div class="col-12 col-md-6">
                      <div class="form-group">
                        <label for="refno" class="form-label">Ref NO<span class="text-danger">*</span></label>
                        <input class="form-control" type="text" formControlName="refno" placeholder="Case/Notice Ref No" />
                        @if (FormAddNoticeCaseorClosed.get('refno').touched && FormAddNoticeCaseorClosed.get('refno').invalid) {
                          <mat-error>
                            @if (FormAddNoticeCaseorClosed.get('refno').errors?.['required']) {
                              Ref No is required.
                            }
                          </mat-error>
                        }
                      </div>
                    </div>
                  </div>
                }@else{
                  <div [hidden]="HideCaseNotice">
                    <div class="col-sm-4 height-34">Date*</div>
                    <div class="col-sm-5">
                      <mat-form-field class="fullwidth">
                        <input matInput [readonly]="!editable" [min]="minDate" formControlName="Date" [max]="maxDate"
                          [matDatepicker]="pickerevent" placeholder="Choose Case/Notice Date" />
                        <mat-datepicker-toggle matSuffix [for]="pickerevent"></mat-datepicker-toggle>
                        <mat-datepicker #pickerevent></mat-datepicker>
                        @if (FormAddNoticeCaseorClosed.get('Date').touched && FormAddNoticeCaseorClosed.get('Date').invalid) {
                          <mat-error>
                            @if (FormAddNoticeCaseorClosed.get('Date').errors?.['required']) {
                              Date is required.
                            }
                          </mat-error>
                        }
                      </mat-form-field>
                    </div>
                    <div class="col-sm-3">&nbsp;</div>
      
                    <div class="col-sm-12">
                      <hr />
                    </div>
                    <div class="col-sm-4 height-34">Ref NO*</div>
                    <div class="col-sm-5">
                      <input class="form-control" type="text" formControlName="refno" placeholder="Case/Notice Ref No" />
                      @if (FormAddNoticeCaseorClosed.get('refno').touched && FormAddNoticeCaseorClosed.get('refno').invalid) {
                        <mat-error>
                          @if (FormAddNoticeCaseorClosed.get('refno').errors?.['required']) {
                            Ref No is required.
                          }
                        </mat-error>
                      }
                    </div>
                    <div class="col-sm-3">&nbsp;</div>
                    <div class="col-sm-12">
                      <hr />
                    </div>
                  </div>

                }
  
                <div class="d-flex align-items-center justify-content-center mt-3">
                  <button class="btn btn-primary submit-btn small" type="submit">
                    Save
                  </button>
                </div>
                <!-- <div class="col-sm-4">&nbsp;</div>
                <div class="col-sm-5">
                  <input class="btn btn-primary" type="submit" value="Save" />
                </div>
                <div class="col-sm-3">&nbsp;</div> -->
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- modal-dialog--End -->
  <div class="container-fluid">
  <div class="page-heading d-flex align-items-center justify-content-between my-4 px-2">
    Corporate Decision
    <span class="page-status text-danger">{{ PageStatus }}</span>
    <button class="btn btn-outline-primary" title="Go Back" (click)="goBack()">
        <i class="fa fa-arrow-left"></i> Back
      </button>
  </div>
  <form [formGroup]="addFormDecision" (ngSubmit)="onSubmit(addFormDecision.value)">
  <div class="card rounded-4 border-0">
    <div class="card-body">
        <div class="row">
          <div class="col-12 col-md-4">
            <div class="form-group">
              <label for="DecisionID">{{Captions?.decision_point}} <span class="text-danger" >*</span> </label>
                <input class="form-control" formControlName="Description" autocomplete="off" autofocus
                  [placeholder]="'Enter' + Captions?.decision_point" name="Description" type="text" value="" />
                  @if (f.Description.touched && f.Description.invalid) {
                    <div class="text-danger">
                      @if (f.Description.errors?.['required']) {
                        <small>{{Captions?.decision_point}} is required.</small>
                      }
                    </div>
                  }
            </div>
          </div>
          <div class="col-12 col-md-4">
            <div class="form-group">
              <label for="DateofDecision">{{Captions?.date_of_decision}} <span class="text-danger" >*</span> </label>
                <mat-form-field class="fullwidth" appearance="outline" >
                  <input matInput [readonly]="!editable" [min]="minDate" formControlName="DateofDecision"
                    [max]="maxDate" [matDatepicker]="picker4" placeholder="Choose a date" />
                  <mat-datepicker-toggle matSuffix [for]="picker4"></mat-datepicker-toggle>
                  <mat-datepicker #picker4></mat-datepicker>
                </mat-form-field>
            </div>
          </div>
          <div class="col-12 col-md-4">
            <div class="form-group">
              <label for="ActionType">{{Captions?.type_of_action}} <span class="text-danger" >*</span> </label>
              <ng-select [items]="typeOfAction" [closeOnSelect]="false" bindLabel="MainDescr"
                bindValue="hdID" formControlName="ActionType" [placeholder]="'Select ' + Captions?.type_of_action">
                <ng-template ng-option-tmp let-item="item">
                  {{ item.MainDescr }}
                </ng-template>
              </ng-select>
                <!-- <textarea class="form-control" formControlName="ActionType" autocomplete="off"
                  [placeholder]="'Enter' + Captions?.type_of_action" name="Description" type="text" value="" > </textarea> -->
                  @if (f.ActionType.touched && f.ActionType.invalid) {
                    <div class="text-danger">
                      @if (f.ActionType.errors?.['required']) {
                        <small>{{Captions?.type_of_action}} is required.</small>
                      }
                    </div>
                  }
            </div>
          </div>
          <div class="col-12 col-md-4">
            <div class="form-group">
              <label for="ActionTakenBy">{{Captions?.action_taken_by}} <span class="text-danger" >*</span> </label>
              <textarea class="form-control" formControlName="ActionTakenBy" autocomplete="off" rows="3"
                  [placeholder]="'Enter' + Captions?.action_taken_by" name="Description" type="text" value="" > </textarea>
                  @if (f.ActionTakenBy.touched && f.ActionTakenBy.invalid) {
                    <div class="text-danger">
                      @if (f.ActionTakenBy.errors?.['required']) {
                        <small>{{Captions?.action_taken_by}} is required.</small>
                      }
                    </div>
                  }
            </div>
          </div>
          <div class="col-12 col-md-4">
            <div class="form-group">
              <label for="BriefFacts">{{Captions?.brief_facts}} <span class="text-danger" >*</span> </label>
                <textarea class="form-control" formControlName="BriefFacts" autocomplete="off" placeholder="Brief Facts"
                  name="Description" rows="3"></textarea>
                </div>
                @if (f.BriefFacts.touched && f.BriefFacts.invalid) {
                  <div class="text-danger">
                    @if (f.BriefFacts.errors?.['required']) {
                      <small>{{Captions?.brief_facts}} is required.</small>
                    }
                  </div>
                }
          </div>
          <div class="col-12 col-md-4">
            <div class="form-group">
              <label for="TargetDate">{{Captions?.target_date}} <span class="text-danger" >*</span> </label>
                <mat-form-field class="fullwidth" appearance="outline" >
                  <input matInput [readonly]="!editable" [min]="minDate" formControlName="TargetDate"
                    [max]="maxDate" [matDatepicker]="picker5" placeholder="Choose a date" />
                  <mat-datepicker-toggle matSuffix [for]="picker5"></mat-datepicker-toggle>
                  <mat-datepicker #picker5></mat-datepicker>
                </mat-form-field>
                @if (f.TargetDate.touched && f.TargetDate.invalid) {
                  <mat-error>
                    @if (f.TargetDate.errors?.['required']) {
                      {{Captions?.target_date}} is required.
                    }
                  </mat-error>
                }
            </div>
          </div>
          <div class="col-12 col-md-4">
            <div class="form-group">
              <label for="DueDate">{{Captions?.due_date_if_any}}  </label>
                <mat-form-field class="fullwidth" appearance="outline" >
                  <input matInput [readonly]="!editable" [min]="minDate" formControlName="DueDate"
                    [max]="maxDate" [matDatepicker]="picker6" placeholder="Choose a date" />
                  <mat-datepicker-toggle matSuffix [for]="picker6"></mat-datepicker-toggle>
                  <mat-datepicker #picker6></mat-datepicker>
                </mat-form-field>
                @if (f.DueDate.touched && f.DueDate.invalid) {
                  <mat-error>
                    @if (f.DueDate.errors?.['required']) {
                      {{Captions?.due_date}} is required.
                    }
                  </mat-error>
                }
            </div>
          </div>
            <div class="col-12 col-md-4">
              <div class="form-group">
                <label><a routerLink="/addorgcontact/0/0" target="_blank">{{Captions?.filing_party}}</a> <span class="text-danger" >*</span> </label>
                <ng-select [items]="filteredFillingParty" [multiple]="true" [closeOnSelect]="false" bindLabel="Name"
                  bindValue="ID" formControlName="fillingPartyName" [placeholder]="'Select'+Captions.filing_party">

                  <ng-template ng-option-tmp let-item="item">
                    {{ item.Name }}
                  </ng-template>

                </ng-select>
                @if (f.fillingPartyName.touched && f.fillingPartyName.invalid) {
                  <div class="text-danger">
                    @if (f.fillingPartyName.errors?.['required']) {
                      <small>{{Captions?.filing_party}} is required.</small>
                    }
                  </div>
                }
              </div>
            </div>
            <div class="col-12 col-md-4">
              <div class="form-group">
                <label><a routerLink="/addorgcontact/0/0" target="_blank">{{Captions?.opposite_party}}</a> <span class="text-danger" >*</span> </label>
                <ng-select [items]="filteredOppositeParty" [multiple]="true" [closeOnSelect]="false" bindLabel="Name"
                  bindValue="ID" formControlName="oppositePartyName" [placeholder]="'Select '+Captions.opposite_party">

                  <ng-template ng-option-tmp let-item="item">
                    {{ item.Name }}
                  </ng-template>

                </ng-select>
                @if (f.oppositePartyName.touched && f.oppositePartyName.invalid) {
                  <div class="text-danger">
                    @if (f.oppositePartyName.errors?.['required']) {
                      <small>{{Captions?.opposite_party}} is required.</small>
                    }
                  </div>
                }
              </div>
            </div>
          <div class="col-12 col-md-4">
            <div class="form-group">
              <label for="Product"><a routerLink="/addorgcontact/0/0" target="_blank">{{Captions?.product}}</a> <span class="text-danger" >*</span> </label>
                <ng-select [items]="ProductHelpList" [clearable]="false" [multiple]="true" formControlName="HelpProduct"
                  bindLabel="MainDescr" [selectableGroup]="true" [closeOnSelect]="true" bindValue="hdID">
                  <ng-template ng-option-tmp let-item="item" let-item$="item$" let-index="index">
                    {{ item.MainDescr }}
                  </ng-template>
                </ng-select>
                @if (f.HelpProduct.touched && f.HelpProduct.invalid) {
                  <div class="text-danger">
                    @if (f.HelpProduct.errors?.['required']) {
                      <small>{{Captions?.product}} is required.</small>
                    }
                  </div>
                }
            </div>
          </div>
          <div class="col-12 col-md-4">
            <div class="form-group">
              <label for="Manager"><a routerLink="{{ RouteUserMaster }}" target="_blank">{{Captions?.responsible_person}}</a> <span class="text-danger" >*</span> </label>
                <ng-select formControlName="Manager" [items]="Manager" bindLabel="name" bindValue="id1"
                  [placeholder]="'Select '+Captions.responsible_person" [clearable]="false">
                </ng-select>
                @if (f.Manager.touched && f.Manager.invalid) {
                  <div class="text-danger">
                    @if (f.Manager.errors?.['required']) {
                      <small>{{Captions?.responsible_person}} is required.</small>
                    }
                  </div>
                }
            </div>
          </div>
          <div class="col-12 col-md-4">
            <div class="form-group">
              <label for="Leader"><a routerLink="{{ RouteUserMaster }}" target="_blank">{{Captions?.responsible_leader}}</a> </label>
                <ng-select formControlName="Leader" [items]="Manager" bindLabel="name" bindValue="id1"
                  [placeholder]="'Select '+Captions.responsible_leader" [clearable]="false">
                  <ng-option [value]="0">Not Selected</ng-option>
                </ng-select>
                @if (f.Leader.touched && f.Leader.invalid) {
                  <div class="text-danger">
                    @if (f.Leader.errors?.['required']) {
                      <small>{{Captions?.responsible_leader}} is required.</small>
                    }
                  </div>
                }
            </div>
          </div>
          <div class="col-12 col-md-4">
            <div class="form-group">
              <label for="Agency"><a routerLink="{{ RouteGMAgency }}" target="_blank">{{Captions?.agency}}</a> <span class="text-danger" >*</span> </label>
                <ng-select formControlName="Agency" [items]="Agency" bindLabel="MainDescr" bindValue="hdID"
                  [placeholder]="'Select '+Captions.agency" [searchable]="true" [clearable]="false">
                  <ng-option [value]="0">Not Selected</ng-option>
                </ng-select>
                @if (f.Agency.touched && f.Agency.invalid) {
                  <div class="text-danger">
                    @if (f.Agency.errors?.['required']) {
                      <small>{{Captions?.agency}} is required.</small>
                    }
                  </div>
                }
            </div>
          </div>
          <div class="col-12 col-md-4">
            <div class="form-group">
              <label for="Category"><a routerLink="{{ RouteGMCategory }}" target="_blank">{{Captions?.category}}</a> <span class="text-danger" >*</span> </label>
              <ng-select formControlName="Category" [items]="Category" bindLabel="MainDescr" bindValue="hdID"
                [placeholder]="'Select '+Captions.category" [clearable]="false" (change)="onCategorySelect($event)">
                <ng-option [value]="0">Not Selected</ng-option>
              </ng-select>
              @if (f.Category.touched && f.Category.invalid) {
                <div class="text-danger">
                  @if (f.Category.errors?.['required']) {
                    <small>{{Captions?.category}} is required.</small>
                  }
                </div>
              }
            </div>
          </div>
          <div class="col-12 col-md-4">
            <div class="form-group">
              <label for="Category"><a
                  routerLink="{{ RouteGMSubCategory }}" target="_blank">{{Captions?.subcategory}}</a> <span class="text-danger" >*</span> </label>
                  <ng-select formControlName="SubCategory" [items]="SubCategory" bindLabel="MainDescr" bindValue="hdID"
                    [appendTo]="'body'" [placeholder]="'Select '+Captions.subcategory" [clearable]="false">
                    <ng-option [value]="0">Not Selected</ng-option>
                  </ng-select>
                  @if (f.SubCategory.touched && f.SubCategory.invalid) {
                    <div class="text-danger">
                      @if (f.SubCategory.errors?.['required']) {
                        <small>{{Captions?.subcategory}} is required.</small>
                      }
                    </div>
                  }
            </div>
          </div>
          <div class="col-12 col-md-4">
            <div class="form-group">
              <label for="Company"><a routerLink="{{ RouteCompany }}" target="_blank">{{Captions?.company}}</a> <span class="text-danger" >*</span> </label>
                <ng-select formControlName="Company" [items]="Company" bindLabel="Name" bindValue="ID"
                  [placeholder]="'Select '+Captions.company" [clearable]="false">
                  <ng-option [value]="0">Not Selected</ng-option>
                </ng-select>
                @if (f.Company.touched && f.Company.invalid) {
                  <div class="text-danger">
                    @if (f.Company.errors?.['required']) {
                      <small>{{Captions?.company}} is required.</small>
                    }
                  </div>
                }
            </div>
          </div>
          <div class="col-12 col-md-4">
            <div class="form-group">
              <label for="Department"><a routerLink="{{ RouteGMDepartment }}"
                  target="_blank">{{Captions?.department}}</a> <span class="text-danger" >*</span> </label>
              <ng-select formControlName="Department" [items]="Department" bindLabel="MainDescr" bindValue="hdID"
                [placeholder]="'Select '+Captions.department" [clearable]="false">
                <ng-option [value]="0">Not Selected</ng-option>
              </ng-select>
              @if (f.Department.touched && f.Department.invalid) {
                <div class="text-danger">
                  @if (f.Department.errors?.['required']) {
                    <small>{{Captions?.department}} is required.</small>
                  }
                </div>
              }
            </div>
          </div>
          <div class="col-12 col-md-4">
            <div class="form-group">
              <label for="ExposureAmmount">Exposure Amount<span class="text-danger" >*</span> </label>
              <input class="form-control" formControlName="ExposureAmmount" placeholder="Exposure Amount" step="0.01"
                name="exposureamount" type="number" value="" />
              @if (f.ExposureAmmount.touched && f.ExposureAmmount.invalid) {
                <div class="text-danger">
                  @if (f.ExposureAmmount.errors?.['required']) {
                    <small>{{Captions?.exposureamount}} is required.</small>
                  }
                </div>
              }
            </div>
          </div>
          <div class="col-12 col-md-4">
            <div class="form-group">
              <label for="Currency"><a routerLink="{{ RouteGMCurrency }}" target="_blank">{{Captions?.currency}}</a> <span class="text-danger" >*</span> </label>
              <ng-select
                formControlName="Currency"
                [items]="Currency"
                bindLabel="MainDescr"
                bindValue="hdID"
                [clearable]="false"
                [placeholder]="'Select '+Captions.currency"
                [searchable]="true">
                <ng-option [value]="0">Not Selected</ng-option>
              </ng-select>
              @if (f.Currency.touched && f.Currency.invalid) {
                <div class="text-danger">
                  @if (f.Currency.errors?.['required']) {
                    <small>{{Captions?.currency}} is required.</small>
                  }
                </div>
              }
            </div>
          </div>
          <div class="col-12 col-md-4">
            <div class="form-group">
              <label for="State"><a routerLink="{{ RouteGMState }}" target="_blank">{{Captions?.state}}</a> <span class="text-danger" >*</span> </label>
              <ng-select
                formControlName="State"
                [items]="State"
                bindLabel="MainDescr"
                bindValue="hdID"
                [placeholder]="'Select '+Captions.state"
                (change)="onStateSelect($event)"
                [clearable]="false"
                [searchable]="true">
                <ng-option [value]="0">Not Selected</ng-option>
              </ng-select>
              @if (f.State.touched && f.State.invalid) {
                <div class="text-danger">
                  @if (f.State.errors?.['required']) {
                    <small>{{Captions?.state}} is required.</small>
                  }
                </div>
              }
            </div>
          </div>
          <div class="col-12 col-md-4">
            <div class="form-group">
              <label for="City"><a routerLink="{{ RouteGMCity }}" target="_blank">{{Captions?.city}}</a> <span class="text-danger" >*</span> </label>
              <ng-select
                formControlName="City"
                [items]="City"
                bindLabel="MainDescr"
                bindValue="hdID"
                [placeholder]="'Select '+Captions.city"
                (change)="onCitySelect($event)"
                [clearable]="false"
                [searchable]="true">
                <ng-option [value]="0">Not Selected</ng-option>
              </ng-select>
              @if (f.City.touched && f.City.invalid) {
                <div class="text-danger">
                  @if (f.City.errors?.['required']) {
                    <small>{{Captions?.city}} is required.</small>
                  }
                </div>
              }
            </div>
          </div>
          <div class="col-12 col-md-4">
            <div class="form-group" [hidden]="HideStatus" >
              <label for="Status">{{Captions?.status}} <span class="text-danger" >*</span> </label>
              <ng-select
                formControlName="Status"
                [items]="[
                  {label:'Open', value:0},
                  {label:'Hold', value:1},
                  {label:'Closed', value:2}
                ]"
                bindLabel="label"
                bindValue="value"
                (change)="onStatusSelect($event)"
                placeholder="Open"
                [clearable]="false">
              </ng-select>
              @if (f.Status.touched && f.Status.invalid) {
                <div class="text-danger">
                  @if (f.Status.errors?.['required']) {
                    <small>{{Captions?.status}} is required.</small>
                  }
                </div>
              }
            </div>
          </div>
          <div class="col-12 col-md-4">
            <div class="form-group">
              <label> <a routerLink="{{ RouteGMJurisdiction }}" target="_blank">{{Captions?.jurisdiction_court_name}}</a> <span class="text-danger" >*</span> </label>
              <ng-select
                formControlName="Jurisdiction"
                [items]="Jurisdiction"
                bindLabel="MainDescr"
                bindValue="hdID"
                [placeholder]="'Select '+Captions.jurisdiction_court_name"
                [clearable]="false"
                [searchable]="true">
                <ng-option [value]="0">Not Selected</ng-option>
              </ng-select>
            @if (f.Jurisdiction.touched && f.Jurisdiction.invalid) {
                <div class="text-danger">
                  @if (f.Jurisdiction.errors?.['required']) {
                    <small>{{Captions?.jurisdiction_court_name}} is required.</small>
                  }
                </div>
              }

            </div>
          </div>
          <div class="col-12 col-md-4">
            <div class="form-group">
              <label for="Attachments">Attachments(if any)</label>
                <input type="file" (change)="onSelectFile($event)" multiple />
            </div>
          </div>
          <!-- @if (!HideClosed) { -->
            <!-- <div class="col-12 col-md-4">
              <div>Reason For Closed*</div>
              {{ CaptionLabel }}
            </div> -->
            <div class="col-12 col-md-4" [hidden]="HideClosed">
              <label for="reason">{{Captions?.reason_for_closed}} <span class="text-danger" >*</span> </label>
              <div>
                <input class="form-control" formControlName="reason" autocomplete="off"
                  [placeholder]="'Enter'+Captions.reason_for_closed" name="ReasonForClosed" type="text" value="" />
              </div>
              @if (f.reason.touched && f.reason.invalid) {
                <div class="text-danger">
                  @if (f.reason.errors?.['required']) {
                    <small>{{Captions?.reason_for_closed}} is required.</small>
                  }
                </div>
              }
            </div>
          <!-- } -->
          @if (CommunityDisplayRegionBranch == '1') {
          <div class="col-12 col-md-4">
            <div class="form-group">
              <label for="Region"><a routerLink="{{ RouteGMRegion }}" target="_blank">{{Captions?.region}}</a> <span class="text-danger" >*</span> </label>
              <ng-select
                formControlName="Region"
                [items]="Region"
                bindLabel="MainDescr"
                bindValue="hdID"
                [placeholder]="'Select '+Captions.region"
                (change)="onRegionSelect($event)"
                [clearable]="false"
                [searchable]="true">
                <ng-option [value]="0">Select Region</ng-option>
              </ng-select>
              @if (f.Region.touched && f.Region.invalid) {
                <div class="text-danger">
                  @if (f.Region.errors?.['required']) {
                    <small>{{Captions?.region}} is required.</small>
                  }
                </div>
              }
            </div>
          </div>
          <div class="col-12 col-md-4">
            <div class="form-group">
              <label for="Branch"><a routerLink="{{ RouteGMBranch }}" target="_blank">{{Captions?.branch}}</a> <span class="text-danger" >*</span> </label>
              <ng-select
                formControlName="Branch"
                [items]="Branch"
                bindLabel="MainDescr"
                bindValue="hdID"
                [placeholder]="'Select '+Captions.branch"
                [clearable]="false"
                [searchable]="true">
                <ng-option [value]="0">Not Selected</ng-option>
              </ng-select>
              @if (f.Branch.touched && f.Branch.invalid) {
                <div class="text-danger">
                  @if (f.Branch.errors?.['required']) {
                    <small>{{Captions?.branch}} is required.</small>
                  }
                </div>
              }
            </div>
          </div>
          }
        </div>
      </div>
    </div>
    @if (RightsID.includes('202038001') || RightsID.includes('20203821')) {
      <div class="d-flex align-items-center justify-content-center mt-3" [hidden]="HideButtonSubmit">
        <button class="btn btn-primary submit-btn" [type]="DisplaySaveNoticeButton" [disabled]="clicked">
          {{ HeaderButtonCaption }}
        </button>
      </div>
    }
  </form>
  <div class="card border-0 rounded-4 my-3" [hidden]="HideButtonSubmit">
    <div class="card-body p-3 d-flex justify-content-between">
        <button
          *ngIf="RightsID.includes('202046001') || RightsID.includes('202046021'); else FollowUp"
          class="status-action-btn add-to-followup"
          (click)="OpenModal1('afuc', '0', 'FetchDescisionHistory', 'Add Follow UP')"
          data-toggle="modal"
          data-target="#ModalPopUP1">
          <i class="fa fa-comments"></i> {{ AddFollowupLink }}
        </button>
        <ng-template #FollowUp>
          <a routerLink="/module/0" class="btn btn-outline-secondary btn-block action-btn">
            <i class="fa fa-comments"></i> {{ AddFollowupLink }}
          </a>
        </ng-template>
        <button
          *ngIf="RightsID.includes('202024001') || RightsID.includes('202024021'); else AddDiary"
          class="status-action-btn add-to-diary"
          (click)="OpenModal1('ndc', '0', 'FetchDescisionHistory', 'Add Diary')"
          data-toggle="modal"
          data-target="#ModalPopUP1">
           <i class="fa-solid fa-book"></i> Add To Diary
        </button>
        <ng-template #AddDiary>
          <a routerLink="/module/0" class="btn btn-outline-secondary btn-block action-btn">
             <i class="fa-solid fa-book"></i> Add To Diary
          </a>
        </ng-template>

          <!-- <button class="status-action-btn print-notice">
              <i class="fa-solid fa-print"></i> Print Notice
          </button> -->
  
      <!-- Convert to Notice -->
        <button
          *ngIf="RightsID.includes('202030001') || RightsID.includes('202030021'); else ConvertNotice"
          class="status-action-btn convert-to-case"
          (click)="ConvertToNotice()">
          <i class="fa fa-exchange"></i> Convert to Notice
        </button>
        <ng-template #ConvertNotice>
          <a routerLink="/module/0" class="btn btn-outline-secondary btn-block action-btn">
            <i class="fa fa-exchange"></i> Convert to Notice
          </a>
        </ng-template>

              <!-- Convert to Case -->
        <button
          *ngIf="RightsID.includes('202032001') || RightsID.includes('202032021'); else ConvertCase"
          class="status-action-btn convert-to-case"
          (click)="ConvertToCase()">
          <i class="fa-solid fa-folder-open"></i> Convert to Case
        </button>
        <ng-template #ConvertCase>
          <a routerLink="/module/0" class="btn btn-outline-secondary btn-block action-btn">
            <i class="fa-solid fa-folder-open"></i> Convert to Case
          </a>
        </ng-template>

                <!-- Evaluation Form -->
        <button
          class="status-action-btn evolution"
          (click)="OpenModal('evalentry', '1', 'FetchDescisionHistory', 'Evaluation Form')"
          data-toggle="modal"
          data-target="#ModalPopUP1">
         <i class="fa-solid fa-circle-check"></i> Evaluation Form
        </button>
    </div>
  </div>
  
<!-- @if (false) {
  <div class="card rounded-4 my-3" [hidden]="HideButtonSubmit">
    <div class="card-body p-3 d-flex justify-content-between">
      <div class="col-sm-2">
        <button
          *ngIf="RightsID.includes('202046001') || RightsID.includes('202046021'); else FollowUp"
          class="btn btn-primary btn-block action-btn"
          (click)="OpenModal1('afuc', '0', 'FetchDescisionHistory', 'Add Follow UP')"
          data-toggle="modal"
          data-target="#ModalPopUP1">
          <i class="fa fa-comments"></i> {{ AddFollowupLink }}
        </button>
        <ng-template #FollowUp>
          <a routerLink="/module/0" class="btn btn-outline-secondary btn-block action-btn">
            <i class="fa fa-comments"></i> {{ AddFollowupLink }}
          </a>
        </ng-template>
      </div>
  
      <div class="col-sm-2">
        <button
          *ngIf="RightsID.includes('202024001') || RightsID.includes('202024021'); else AddDiary"
          class="btn btn-success btn-block action-btn"
          (click)="OpenModal1('ndc', '0', 'FetchDescisionHistory', 'Add Diary')"
          data-toggle="modal"
          data-target="#ModalPopUP1">
          <i class="fa fa-book"></i> Add To Diary
        </button>
        <ng-template #AddDiary>
          <a routerLink="/module/0" class="btn btn-outline-secondary btn-block action-btn">
            <i class="fa fa-book"></i> Add To Diary
          </a>
        </ng-template>
      </div>
  
      <div class="col-sm-2">
        <button
          *ngIf="RightsID.includes('202030001') || RightsID.includes('202030021'); else ConvertNotice"
          class="btn btn-warning btn-block action-btn"
          (click)="ConvertToNotice()">
          <i class="fa fa-exchange"></i> Convert to Notice
        </button>
        <ng-template #ConvertNotice>
          <a routerLink="/module/0" class="btn btn-outline-secondary btn-block action-btn">
            <i class="fa fa-exchange"></i> Convert to Notice
          </a>
        </ng-template>
      </div>
  
      <div class="col-sm-2">
        <button
          *ngIf="RightsID.includes('202032001') || RightsID.includes('202032021'); else ConvertCase"
          class="btn btn-danger btn-block action-btn"
          (click)="ConvertToCase()">
          <i class="fa fa-briefcase"></i> Convert to Case
        </button>
        <ng-template #ConvertCase>
          <a routerLink="/module/0" class="btn btn-outline-secondary btn-block action-btn">
            <i class="fa fa-briefcase"></i> Convert to Case
          </a>
        </ng-template>
      </div>
  
      <div class="col-sm-2">
        <button
          class="btn btn-info btn-block action-btn"
          (click)="OpenModal('evalentry', '1', 'FetchDescisionHistory', 'Evaluation Form')"
          data-toggle="modal"
          data-target="#ModalPopUP1">
         <i class="fa-solid fa-circle-check"></i> Evaluation Form
        </button>
      </div>
    </div>
  </div>
} -->
  </div>


  <!-- <div class="col-sm-12 mt-2 text-center">
    <ul class="nav nav-tabs custom-tabs">
      <li class="active">
        <a data-toggle="tab" class="tab-title" href="#ChequeBounceDetails">Cheque Bounce Details</a>
      </li>
    </ul>
  </div> -->
  <!-- <li>
    <a data-toggle="tab" class="tab-title" href="#factSheet">Fact Sheet</a>
  </li> -->
  <div class="col-sm-12 mt-2">
    <div class="tab-content border-0">
      <div id="ChequeBounceDetails" class="tab-pane fade in active">
        <!--Cheque Bounce Form Start-->
        @if (false) {
          <form [formGroup]="ChequeBouncingForm" (ngSubmit)="onChequeBouncingUpdate(ChequeBouncingForm.value)">
              <div class="card rounded-4 border-0">
                <div class="card-body">
                    <div class="page-sub-heading mb-3">
                      Cheque Bouncing Details
                    </div>
                    <div class="row">
                      <div class="col-md-4">
                        <div class="form-group">
                          <label for="AmountDue" class="form-label">Amount Due <span class="text-danger">*</span></label>
                          <input type="number" class="form-control" (change)="onChangeAmountDue($event.target.value)"
                            formControlName="AmountDue" placeholder="Amount Due">
                            @if (c.AmountDue.touched && c.AmountDue.invalid) {
                              <div class="text-danger">
                                <small>Amount Due is required.</small>
                              </div>
                            }
                        </div>
                      </div>
                      <div class="col-md-4">
                        <div class="form-group">
                          <label for="DateofReceivingAmount" class="form-label">Date of Receiving Amount <span class="text-danger">*</span></label>
                          <mat-form-field class="fullwidth" appearance="outline">
                            <input matInput [matDatepicker]="DateofReceivingAmount"
                              formControlName="DateofReceivingAmount" placeholder="Date of Receiving Amount">
                            <mat-datepicker-toggle matSuffix [for]="DateofReceivingAmount"></mat-datepicker-toggle>
                            <mat-datepicker #DateofReceivingAmount></mat-datepicker>
                            @if (c.DateofReceivingAmount.touched && c.DateofReceivingAmount.invalid) {
                              <mat-error>Date of Receiving Amount is required.</mat-error>
                            }
                          </mat-form-field>
                        </div>
                      </div>
                      <div class="col-md-4">
                        <div class="form-group">
                          <label for="ReceivingAmount" class="form-label">Receiving Amount <span class="text-danger">*</span></label>
                          <input type="number" class="form-control" formControlName="ReceivingAmount"
                            placeholder="Receiving Amount" (change)="onChangeReceivingAmount($event.target.value)">
                            @if (c.ReceivingAmount.touched && c.ReceivingAmount.invalid) {
                              <div class="text-danger">
                                <small>Receiving Amount is required.</small>
                              </div>
                            }
                        </div>
                      </div>
                      <div class="col-md-4">
                        <div class="form-group">
                          <label for="ModeOfPayment" class="form-label">Mode of Payment <span class="text-danger">*</span></label>
                          <input type="text" class="form-control" formControlName="ModeOfPayment"
                            placeholder="Mode of Payment">
                            @if (c.ModeOfPayment.touched && c.ModeOfPayment.invalid) {
                              <div class="text-danger">
                                <small>Mode of Payment is required.</small>
                              </div>
                            }
                        </div>
                      </div>
                      <div class="col-md-4">
                        <div class="form-group">
                          <label for="againstchequebouncing" class="form-label">O/S against cheque bouncing <span class="text-danger">*</span></label>
                          <input type="text" class="form-control" formControlName="againstchequebouncing">
                            @if (c.againstchequebouncing.touched && c.againstchequebouncing.invalid) {
                              <div class="text-danger">
                                <small>O/S against cheque bouncing is required.</small>
                              </div>
                            }
                        </div>
                      </div>
                      <div class="col-md-4">
                        <div class="form-group">
                          <label for="TotalOSFromParty" class="form-label">Total O/S From Party <span class="text-danger">*</span></label>
                          <input type="text" class="form-control" formControlName="TotalOSFromParty">
                            @if (c.TotalOSFromParty.touched && c.TotalOSFromParty.invalid) {
                              <div class="text-danger">
                                <small>Total O/S From Party is required.</small>
                              </div>
                            }
                        </div>
                      </div>
                    </div>
                    <div class="page-sub-heading mt-2">
                      Payment Details
                    </div>
                    <div class="row">
                      <div class="col-md-4">
                        <div class="form-group">
                          <label for="ChequeDate" class="form-label">Cheque Date <span class="text-danger">*</span></label>
                          <mat-form-field class="fullwidth" appearance="outline">
                            <input matInput [matDatepicker]="ChequeDate" formControlName="ChequeDate"
                              placeholder="Cheque Date">
                            <mat-datepicker-toggle matSuffix [for]="ChequeDate"></mat-datepicker-toggle>
                            <mat-datepicker #ChequeDate></mat-datepicker>
                          </mat-form-field>
                          @if (c.ChequeDate.touched && c.ChequeDate.invalid) {
                            <div class="text-danger">
                              <small>Cheque Date is required.</small>
                            </div>
                          }
                        </div>
                      </div>
                      <div class="col-md-4">
                        <div class="form-group">
                          <label for="ChequeNo" class="form-label">Cheque No. <span class="text-danger">*</span></label>
                          <input type="text" class="form-control" formControlName="ChequeNo" placeholder="Cheque No.">
                            @if (c.ChequeNo.touched && c.ChequeNo.invalid) {
                              <div class="text-danger">
                                <small>Cheque No. is required.</small>
                              </div>
                            }
                        </div>
                      </div>
                      <div class="col-md-4">
                        <div class="form-group">
                          <label for="ChequeAmount" class="form-label">Cheque Amount <span class="text-danger">*</span></label>
                          <input type="number" class="form-control" formControlName="ChequeAmount"
                            placeholder="Cheque Amount">
                            @if (c.ChequeAmount.touched && c.ChequeAmount.invalid) {
                              <div class="text-danger">
                                <small>Cheque Amount is required.</small>
                              </div>
                            }
                        </div>
                      </div>
                      <div class="col-md-4">
                        <div class="form-group">
                          <label for="DishonorDate" class="form-label">Dishonor Date <span class="text-danger">*</span></label>
                          <mat-form-field class="fullwidth" appearance="outline">
                            <input matInput [matDatepicker]="DishonorDate" formControlName="DishonorDate"
                              placeholder="Select Dishonor Date">
                            <mat-datepicker-toggle matSuffix [for]="DishonorDate"></mat-datepicker-toggle>
                            <mat-datepicker #DishonorDate></mat-datepicker>
                            @if (c.DishonorDate.touched && c.DishonorDate.invalid) {
                              <mat-error>Dishonor Date is required.</mat-error>
                            }
                          </mat-form-field>
                        </div>
                      </div>
                      <div class="col-md-4">
                        <div class="form-group">
                          <label for="DishonorReason" class="form-label">Dishonor Reason <span class="text-danger">*</span></label>
                          <textarea class="form-control" formControlName="DishonorReason" rows="2"
                            placeholder="Dishonor Reason"></textarea>
                            @if (c.DishonorReason.touched && c.DishonorReason.invalid) {
                              <div class="text-danger">
                                <small>Dishonor Reason is required.</small>
                              </div>
                            }
                        </div>
                      </div>
                      <div class="col-md-4">
                        <div class="form-group">
                          <label for="DishonorBank" class="form-label">Dishonor Bank</label>
                          <input type="text" class="form-control" formControlName="DishonorBank"
                            placeholder="Dishonor Bank">
                        </div>
                      </div>
                      <div class="col-md-4">
                        <div class="form-group">
                          <label for="DishonorBankBranch" class="form-label">Dishonor Bank Branch</label>
                          <input type="text" class="form-control" formControlName="DishonorBankBranch"
                            placeholder="Dishonor Bank Branch">
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
        @if (!HideButtonSubmit && RightsID.includes('202038001') || RightsID.includes('20203821')) {
          <div class="d-flex align-items-center justify-content-center my-3">
            <button class="btn btn-primary submit-btn small" type="submit">
              Update
            </button>
          </div>
        }
      </form>
          <div class="card mt-2">
            <table class="custom-table">
              <thead>
                <tr>
                  <th>S.No.</th>
                  <th>Update By</th>
                  <th>Attachments</th>
                  <th>Date/Time</th>
                  <th>Action</th>
                </tr>
              </thead>
              <tbody>
                <app-table-state
                [loading]="loading"
                [error]="factsheetDetailsError ? 'Something went wrong while fetching data.' : null"
                [empty]="factsheetDetail == null"
                [rows]="10"
                [columns]="5">
              </app-table-state>
              <!-- SUCCESS CONTENT GOES HERE -->
              @for (fsD of factsheetDetail ; track $index ; let i = $index) {
                <tr>
                  <td>{{ i + 1 }}</td>
                  <td>{{ fsD.UserName }}</td>
  
                  <td>
                    <table>
                      <tr *ngFor="let fsDFile of fsD.attachment; let i = index">
                        <td>
                          <a href="{{ DownloadURL }}{{ fsDFile.DownloadPath }}" target="_blank">{{ fsDFile.DisplayName
                            }}</a>
                        </td>
                      </tr>
                    </table>
                  </td>
  
                  <td>{{ fsD.fDate }}</td>
                  <td>
                      @for(fsDFile of fsD.attachment ; track $index ; let i = $index) {
                        @if (RightsID.includes('202038021')) {
                          <button
                            class="icon-btn icon-btn-success"
                            title="Download"
                          >
                          <a
                            href="{{ DownloadURL }}{{ fsDFile.DownloadPath }}"
                            target="_blank"
                          >
                            <i class="fa fa-download"></i>
                          </a>
                          </button>
                        } @else {
                           <button
                            class="icon-btn icon-btn-danger"
                            title="Delete"
                          >
                          <a
                            routerLink="/module/0"
                          >
                            <i class="fa fa-trash"></i>
                          </a>
                          </button>
                        }
                      }
                  </td>
                </tr>
              }
              </tbody>
            </table>
          </div>
        }
        <!--Fact Sheet Form End-->
      </div>

      <!--Notice History-->
      <!-- <div id="factSheet" class="tab-pane fade">
        <div class="card rounded-4 border-0">
          <div class="card-body">
            <div class="text-end">
              <button type="button" class="btn btn-primary font-14 btn-sm mb-2" data-toggle="modal" (click)="
                          OpenModal(
                            'afsc',
                            '0',
                            'factSheetData',
                            'Add Fact Sheet'
                          )
                        " data-target="#ModalPopUP">
                <i class="fa fa-plus"></i>
                Add Fact Sheet
              </button>
            </div>
            <div class="card">
              <table class="custom-table">
                <thead>
                  <tr>
                    <th>S.No.</th>
                    <th>Date</th>
                    <th>Time from-To</th>
                    <th>Action Type</th>
                    <th>Action Taken</th>
                    <th>Urgent Files</th>
                    <th>Plan Date</th>
                    <th>Plan Desc</th>
                    <th>Plan Responible User</th>
                    <th>Updated By</th>
                  </tr>
                </thead>
                <tbody>
                  <app-table-state
                  [loading]="loading"
                  [error]="fetchNoticeHistoryDataError ? 'Something went wrong while fetching data.' : null"
                  [empty]="fetchNoticeHistoryData == null"
                  [rows]="10"
                  [columns]="10">
                </app-table-state>
                <tr  *ngFor="let FNHD of fetchNoticeHistoryData; let i = index">
                  <td align="center">{{ i + 1 }}</td>
                  <td>
                    {{ FNHD.FollowDate | date : "dd-MMM-yyyy" }}
                  </td>
                  <td>{{ FNHD.FollowInTime }}-{{ FNHD.FollowOutTime }}</td>
                  <td>{{ FNHD.FollowActionName }}</td>
                  <td>{{ FNHD.FollowActionTaken }}</td>
                  <td>
                    <table>
                      <tr *ngFor="let FNHDFile of FNHD.attachment; let i = index">
                        <td>
                          <a href="{{ DownloadURL }}{{ FNHDFile.DownloadPath }}" target="_blank">{{ FNHDFile.DisplayName
                            }}</a>
                        </td>
                        <td> 
                          <a *ngIf="
                              this.RightsID.includes('202038021');
                              then DelFactFileLink1;
                              else DelFactFile1
                            ">
                          </a>
                          <ng-template #DelFactFileLink1>
                            <button class="icon-btn icon-btn-danger" type="button" (click)="DeleteAttachment(FNHDFile.ID)" title="Delete"><i class="fa fa-trash" aria-hidden="true"></i></button>
                          </ng-template>
                          <ng-template #DelFactFile1>
                            <a class="icon-btn icon-btn-danger text-decoration-none" routerLink="/module/0"> <i class="fa fa-trash"></i></a>
                          </ng-template>
                        </td>
                      </tr>
                    </table>
                  </td>
                  <td>
                    {{ FNHD.PlanDate | date : "dd-MMM-yyyy" }}
                  </td>
                  <td>{{ FNHD.PlanActionTaken }}</td>
                  <td>{{ FNHD.ResponsibleUser }}</td>
                  <td>{{ FNHD.UserName }}</td>
                </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div> -->
      <!--Notice History End-->
    </div>
  </div>
</my-content>
<my-content placeholder="main">
  <div><br />&nbsp;</div>
</my-content>